import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DisableBranchEntity } from '../../domain/entities/DisableBranchEntity'
import type { DisableBranchReasonListedAdminDto } from '@/backend/market'

export class DisableBranchModel extends DisableBranchEntity {
  constructor(dataDto: DisableBranchReasonListedAdminDto) {
    super()
    mapEntityProperties<DisableBranchEntity>(this, dataDto)
  }
}